import { getTenantConfig } from "@/lib/tenant";
import { useTranslation } from "@/lib/i18n";

/**
 * Public footer — tenant dynamic branding.
 */
export function Footer() {
  const tenant = getTenantConfig();
  const { t } = useTranslation();

  return (
    <footer className="mt-20 border-t border-border/60 bg-background">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-2 px-4 py-8 text-sm text-muted-foreground lg:px-6">
        {tenant.brandName === "MindfulMe" ? (
          <span className="flex items-center gap-2 font-black text-slate-900 tracking-tight text-base">
            <span className="relative flex size-5 items-center justify-center">
              <span className="absolute left-0 size-3.5 rounded-full bg-indigo-600" />
              <span className="absolute right-0 size-3.5 rounded-full bg-orange-500 opacity-90 mix-blend-multiply" />
            </span>
            <span>Mindful<span className="text-indigo-600">Me</span></span>
          </span>
        ) : (
          <span className="font-semibold tracking-tight text-primary">{tenant.brandName}</span>
        )}
        <span>© {new Date().getFullYear()} {tenant.brandName}. {t("footer_rights")}</span>
      </div>
    </footer>
  );
}
